module.exports = __webpack_public_path__ + "static/img/3_bg.96c037e0.png";